/* eslint-disable no-param-reassign, no-shadow */

const flashMessage = {
  namespaced: true,
  state: () => ({
    isShow: false,
    type: "default",
    action: "",
    message: "",
    isAuto: true,
    isDisableClose: false,
    top: "",
  }),
  mutations: {
    SHOW_FLASH_MESSAGE(state) {
      state.isShow = true;
    },
    HIDE_FLASH_MESSAGE(state) {
      state.isShow = false;
    },
    SET_TYPE(state, payload) {
      state.type = payload;
    },
    SET_ACTION(state, payload) {
      state.action = payload;
    },
    SET_MESSAGE(state, payload) {
      state.message = payload;
    },
    SET_IS_AUTO(state, payload) {
      state.isAuto = payload;
    },
    SET_IS_DISABLE_CLOSE(state, payload) {
      state.isDisableClose = payload;
    },
    SET_TOP(state, payload) {
      state.top = payload;
    },
  },
  actions: {
    setFlashMessage(context, payload = {}) {
      if (payload.message) {
        context.commit("SET_TYPE", payload.type || "default");
        if (payload.type === "toast") {
          context.commit("SET_ACTION", payload.action || "success");
        }
        context.commit(
          "SET_IS_AUTO",
          payload.isAuto === undefined ? true : payload.isAuto
        );
        context.commit(
          "SET_IS_DISABLE_CLOSE",
          payload.isDisableClose === undefined ? false : payload.isDisableClose
        );

        context.commit("SET_MESSAGE", payload.message);
        context.commit("SHOW_FLASH_MESSAGE");
      }
    },
    closeFlashMessage(context) {
      context.commit("HIDE_FLASH_MESSAGE");
      context.commit("SET_TYPE", "default");
      context.commit("SET_ACTION", "");
      context.commit("SET_MESSAGE", "");
      context.commit("SET_IS_AUTO", true);
    },
  },
};
export default flashMessage;
